export const ADD_FILTER = 'ADD_FILTER';

export interface AddCaseFilterAction {
  type: typeof ADD_FILTER;
  payload: any;
}

export type CaseActionTypes = AddCaseFilterAction;
